import { ISelectedNode } from "../modules/manager/products/products-manager";
import api from "./api";

export const locationExportData = async () => {
	const { data } = await api.get("manager/location/export/");

	return data;
};

export const managerLocation = async (params?: any) => {
	const { data } = await api.get("manager/location/", { params: params });

	return data;
};

export const managerProduct = async (params?: any) => {
	const { data } = await api.get("v2/manager/materials_list/", {
		params: params,
	});
	return data;
};

export const managerProductLeaf = async (params: any) => {
	const { data } = await api.get("manager/materials_leaf/", {
		params: params,
	});
	return data;
};

export const managerProductSelectAll = async (params?: any) => {
	const { data } = await api.get("v2/manager/materials_list/select_all/", {
		params: params,
	});
	return data;
};

export const productBatch = async (batchData: {
	disciplines: ISelectedNode[];
	items: ISelectedNode[];
	objects: number[];
	is_public: number;
	publish_store: boolean;
	publish_location: boolean;
}) => {
	const { data } = await api.post("/manager/batch_publish/", batchData);
	return data;
};

export const productInativateBatch = async (batchData: {
	disciplines: ISelectedNode[];
	items: ISelectedNode[];
	objects: number[];
	is_public: number;
	publish_store: boolean;
	publish_location: boolean;
}) => {
	const { data } = await api.post("/manager/batch_inativate/", batchData);
	return data;
};

export const productReactivateBatch = async (batchData: {
	disciplines: ISelectedNode[];
	items: ISelectedNode[];
	objects: number[];
}) => {
	const { data } = await api.post("/manager/batch_reactivate/", batchData);
	return data;
};

export const productDeleteBatch = async (batchData: {
	disciplines: ISelectedNode[];
	items: ISelectedNode[];
	objects: number[];
}) => {
	const { data } = await api.post("/manager/batch_delete/", batchData);
	return data;
};

export const productUnpublish = async (id: number, product_type: string) => {
	const { data } = await api.post("manager/material/" + id + "/unpublish", {
		product_type: product_type,
	});
	return data;
};

export const productPublish = async (
	id: number,
	product_type: string,
	publish_location: boolean,
	publish_store: boolean
) => {
	let obj = {
		product_type: product_type,
		publish_store: publish_store,
		publish_location: publish_location,
	};
	const { data } = await api.post("manager/material/" + id + "/publish", obj);
	return data;
};

export const productPublishPlaceUpdate = async (params: any) => {
	const { data } = await api.put("manager/material_update_place/", params);
	return data;
};

export const managerProductActivate = async (
	id: number,
	product_type: string
) => {
	const { data } = await api.post("manager/material/" + id + "/activate", {
		product_type: product_type,
	});
	return data;
};

export const managerProductInactivate = async (
	id: number,
	product_type: string
) => {
	const { data } = await api.post("manager/material/" + id + "/inactivate", {
		product_type: product_type,
	});
	return data;
};

export const managerProductRemove = async (
	id: number,
	product_type: string
) => {
	const { data } = await api.post("manager/material/" + id + "/remove", {
		product_type: product_type,
	});
	return data;
};

export const managerProductCount = async (id: number, product_type: string) => {
	const { data } = await api.post("manager/material/" + id + "/count", {
		product_type: product_type,
	});
	return data;
};

export const getSpredsheets = async () => {
	const { data } = await api.get("manager/upload_preview/");
	return data;
};

export const uploadSpredsheets = async (obj: any) => {
	let formData = new FormData();

	obj.forEach((item: any) => {
		formData.append("material_type", item.material_type);
		formData.append("file", item.file === null ? "" : item.file);
	});

	const { data } = await api.post("manager/upload_preview/", formData);
	return data;
};

export const managerUpdatePrice = async (id: number, product_type: string) => {
	const { data } = await api.post("manager/material/" + id + "/update_price", {
		product_type: product_type,
	});
	return data;
};


export const managerUpdatePriceBatch = async (batchData: {
	disciplines: ISelectedNode[];
	items: ISelectedNode[];
	objects: number[];
}) => {
	const { data } = await api.post("/manager/batch_material/price", batchData);
	return data;
};